import { __extends } from "tslib";
import { DetectCustomLabelsRequest, DetectCustomLabelsResponse } from "../models/index";
import { deserializeAws_json1_1DetectCustomLabelsCommand, serializeAws_json1_1DetectCustomLabelsCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DetectCustomLabelsCommand = /** @class */ (function (_super) {
    __extends(DetectCustomLabelsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DetectCustomLabelsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DetectCustomLabelsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DetectCustomLabelsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DetectCustomLabelsResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DetectCustomLabelsCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DetectCustomLabelsCommand(input, context);
    };
    DetectCustomLabelsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DetectCustomLabelsCommand(output, context);
    };
    return DetectCustomLabelsCommand;
}($Command));
export { DetectCustomLabelsCommand };
//# sourceMappingURL=DetectCustomLabelsCommand.js.map